var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.teachers.length && !_vm.loading
        ? _c("div", { staticClass: "soli-grey pa-3" }, [
            _vm._v(
              "\n        Sorry, no teachers are available for this selection\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.buttons && !_vm.autocomplete
        ? _c("v-select", {
            attrs: {
              items: _vm.teacher ? [_vm.teacher] : _vm.teachers,
              value: _vm.value,
              "item-text": "name",
              "item-value": "id",
              label: "Teacher",
              "return-object": _vm.returnObject,
              "prepend-inner-icon": _vm.hideIcon ? null : "people",
              outlined: "",
              dense: "",
              loading: _vm.loading,
              hideDetails: _vm.hideDetails,
              clearable: _vm.clearable,
              rules: _vm.rules,
              "no-data-text": "No teachers available",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              "click:clear": function ($event) {
                return _vm.$emit("clear")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.autocomplete && !_vm.buttons
        ? _c("v-autocomplete", {
            staticClass: "soli-blue-text",
            attrs: {
              outlined: "",
              "return-object": "",
              dense: "",
              loading: _vm.loading,
              value: _vm.value,
              items: _vm.teacher ? [_vm.teacher] : _vm.teachers,
              hideDetails: _vm.hideDetails,
              "prepend-inner-icon": _vm.hideIcon ? null : "people",
              "menu-props": {
                closeOnContentClick: true,
              },
              clearable: _vm.clearable,
              rules: _vm.rules,
              "return-object": _vm.returnObject,
              "item-value": "id",
              "item-text": "name",
              label: "Teacher",
              "no-data-text": "No teachers available",
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event)
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
              },
              "click:clear": function ($event) {
                return _vm.$emit("clear")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.buttons && !_vm.autocomplete
        ? _c(
            "v-list",
            [
              _vm.loading
                ? _c("v-skeleton-loader", {
                    staticClass: "mx-auto",
                    attrs: {
                      "max-width": "300",
                      type: "list-item, list-item, list-item",
                    },
                  })
                : _vm._e(),
              _vm._l(_vm.getTeachers, function (teacher) {
                return _c(
                  "v-list-item",
                  { key: teacher.id },
                  [
                    _c("SoliTeacher", {
                      attrs: { teacher: teacher },
                      on: {
                        input: function ($event) {
                          return _vm.$emit("input", $event)
                        },
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }